export default "__VITE_ASSET__D8x_mAdI__"